<script>
import moment from "@/utils/moment";
import holidayHelper from "@/utils/helpers/holiday";

export default {
  props: {
    day: {
      type: [String, Object, Date],
      required: true
    }
  },
  computed: {
    holiday() {
      return holidayHelper.findHoliday(this.day);
    }
  },
  filters: {
    formatDay(day) {
      return moment(day, holidayHelper.dayFormat).format("DD/MM");
    }
  }
};
</script>

<template>
  <div v-if="holiday">
    Você escolheu o dia
    <b>{{holiday.day | formatDay}}</b>, neste dia não haverá suporte e atendimento!
    <b>Imprevistos</b>,
    <b>reagendamentos</b> ou
    <b>cancelamentos</b> nesse dia serão tratados
    <b>antes</b> ou no
    <b>próximo dia útil</b>. Você está ciente e deseja prosseguir?
  </div>
</template>

<style scoped>
div {
  color: var(--pink);
  margin-bottom: 10px;
  font-size: smaller;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/Holiday.vue